import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory as history } from 'react-router';
import moment from "moment";
import Segmented from "rc-segmented";

import GroupIcon from '@material-ui/icons/Group';
import ExportIcon from '../../../icons/ExportIcon';
import SelectTable from '../../../components/v3/CalibrationScreenV3/SelectTable';
import DateRangePicker from '../../../components/v3/DateRangePicker/DateRangePicker';
import TicketCountProgressOverTimeContainer from '../../../components/v3/Graphs/ChartContainer/TicketCountProgressOverTimeContainer';
import GeneralQuestionCodeChartContainer from '../../../components/v3/Graphs/ChartContainer/GeneralQuestionCodeChartContainer';
import ResponsesChartContainer from '../../../components/v3/Graphs/ChartContainer/ResponsesChartContainer';
import GeneralAggregationChartWithExternalLegendContainer from '../../../components/v3/Graphs/ChartContainer/WithExternalLegend/GeneralAggregationChartWithExternalLegendContainer';
import GeneralAggregationChartWithExternalLegendWithCountContainer from '../../../components/v3/Graphs/ChartContainer/WithExternalLegend/GeneralAggregationChartWithExternalLegendWithCountContainer';
import { colors, dateFormat, yaxis_count, yaxis_percentage } from '../../../constants';
import ToggleButtonGroup from '../../../components/v3/ToggleButtonGroup';
import {
    isDefined, arrayIsNotEmpty, getColorById, getPercentage,
    getPercentageChange, pageLoaded, sortBy, getSelectedIndividualNode
} from '../../../utils';
import { ZRole } from '../../../generated';

import {
    updateProps,
    loadTeamDashboardOverallScreen,
    loadTeamDashboardBreakdownScreen,
    loadSystemDashboardBasicData,
    downloadTeamDashboardReport
} from './TeamDashboardScreenActions';
import LoadingControl from '../../../components/LoadingControl';
import { fetchUserTeamsStats, fetchDomainValues } from '../../../api/v3/DataApi';
class TeamDashboardScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTimePeriodicity: "Weekly",
            selectedPageBreakdown: { value: "Overall" },
            fromDate: moment().startOf('day').subtract(28, 'd').format(dateFormat),
            toDate: moment().endOf('day').format(dateFormat),
            selectedAggregationIdsInLegend: [],
            selectedFilters: []
        };
    }

    componentDidMount() {
        pageLoaded('Team Dashboard');

        this.loadFirstTeam();
    }

    loadFirstTeam = async () => {
        try {
            const response = await fetchUserTeamsStats();
            const domainValues = await fetchDomainValues();

            if (!arrayIsNotEmpty(response.result) || !arrayIsNotEmpty(domainValues.result)) {
                return;
            }

            const supervisorDomain = domainValues.result.find(d => d.dimensionCode === 'S');
            const supervisorDomainId = supervisorDomain.domainId;

            sortBy(response.result, (o) => o.name);
            this.setState({ userTeams: response.result, supervisorDomainId: supervisorDomainId });
            if (response.result.length > 0) {
                this.setState({ currentTeamId: response.result[0].id });
                //this.fetchAgents(response.result[0].id);
                this.props.dispatch(loadTeamDashboardOverallScreen(this.state.fromDate, this.state.toDate, this.state.selectedTimePeriodicity,
                    response.result[0].id, this.state.selectedFilters, supervisorDomainId));
                this.props.dispatch(loadSystemDashboardBasicData());
            }
        } catch (error) {
            console.error('Error fetching teams:', error);
        }
    };

    redirectIfNeeded() {
        const
            {
                currentUser
            } = this.props;
        if (!isDefined(currentUser)) {
            return;
        }

        if (currentUser.RoleId == ZRole.Supervisor || currentUser.RoleId == ZRole.Agent) {
            const url = `${window.location.origin}/Jibe/status`;
            history.push(url);
        }
    }

    setTimePeriodicity = (value) => {
        this.setState({ selectedTimePeriodicity: value });
    }

    setPageBreakdown = (domain) => {
        const { currentTeamId } = this.state;
        this.setState({ selectedPageBreakdown: domain, selectedAggregationIdsInLegend: [] });

        this.props.dispatch(updateProps({
            ticketCountOverTimeStats: undefined,
            jibeProgressOverTimeStats: undefined,
            responseOverTimeStats: undefined,

            ticketCountOverTimeByBreakdownStats: undefined,
            jibeProgressBreakdownOverTimeStats: undefined,
            responseBreakdownOverTimeStats: undefined,
        }));

        //const selectedAgentId = isDefined(this.state.selectedAgent) ? this.state.selectedAgent.map(obj => obj.id).join(',') : undefined;

        if (domain.value === "Overall") {
            this.props.dispatch(loadTeamDashboardOverallScreen(this.state.fromDate, this.state.toDate, this.state.selectedTimePeriodicity,
                currentTeamId, this.state.selectedFilters, this.state.supervisorDomainId));
        }
        else {
            this.props.dispatch(loadTeamDashboardBreakdownScreen(domain.dimensionCode, this.state.fromDate, this.state.toDate, this.state.selectedTimePeriodicity,
                currentTeamId, this.state.selectedFilters, this.initSelectedAggregationIdsInLegend, this.state.supervisorDomainId));
        }
    }

    onSelectNewTimeRange = (fromDate, toDate) => {
        this.setState({
            fromDate: fromDate,
            toDate: toDate
        });
    }

    onApplyFilters = () => {
        const
            {
                fromDate,
                toDate,
                selectedTimePeriodicity,
                currentTeamId
            } = this.state;

        if (this.state.selectedPageBreakdown.value === "Overall") {
            this.props.dispatch(updateProps({
                ticketCountOverTimeStats: undefined,
                jibeProgressOverTimeStats: undefined,
                responseOverTimeStats: undefined,
            }));
            this.props.dispatch(loadTeamDashboardOverallScreen(fromDate, toDate, selectedTimePeriodicity,
                currentTeamId, this.state.selectedFilters, this.state.supervisorDomainId));
        }
        else {
            this.props.dispatch(updateProps({
                ticketCountOverTimeByBreakdownStats: undefined,
                responseBreakdownOverTimeStats: undefined,
                jibeProgressBreakdownOverTimeStats: undefined,
            }));
            this.props.dispatch(loadTeamDashboardBreakdownScreen(this.state.selectedPageBreakdown.dimensionCode,
                fromDate, toDate, selectedTimePeriodicity, currentTeamId, this.state.selectedFilters, this.state.supervisorDomainId));
        }
    }

    getSelectAgentPopup = () => {
        const
            {
                userTeamsStats,
            } = this.props;

        if (!isDefined(userTeamsStats))
            return;

        //To change

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectTeam">
                <SelectTable
                    selectMultiple={true}
                    title="Select team"
                    searchPlaceHolder="Search..."
                    options={userTeamsStats}
                    onClose={this.hideSelectAgentPopup} />
            </div>
        </div>);
    }

    getSelectFilterPopup = () => {
        const
            {
                domainValues
            } = this.props;

        if (!arrayIsNotEmpty(domainValues))
            return;

        const domainObject = domainValues.find(f => f.domainId === this.state.filterIdToShow)
        const newArray = domainObject.domainValues.map(obj => {
            return {
                id: obj.domainValueId,
                name: obj.domainValueName,
                domainId: domainObject.domainId
            };
        });
        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectTeam">
                <SelectTable
                    selectMultiple={true}
                    title="Select "
                    searchPlaceHolder="Search..."
                    options={newArray}
                    onClose={this.hideFilterPopup} />
            </div>
        </div>);
    }

    hideFilterPopup = (newFilters) => {
        this.setState({ showSelectFilterPopup: false });

        const filteredNewFilters = newFilters.filter(newFilter => {
            return !this.state.selectedFilters.some(selectedFilter => selectedFilter.id === newFilter.id);
        });

        this.setState(prevState => ({
            selectedFilters: [...prevState.selectedFilters, ...filteredNewFilters]
        }));
    }

    removeFilter = (domainId) => {
        const updatedFilters = this.state.selectedFilters.filter(filter => filter.id !== domainId);

        this.setState({ selectedFilters: updatedFilters });
    }

    getFilters = () => {
        const
            {
                currentUser,
                domainValues
            } = this.props;
        if (!isDefined(currentUser) || !arrayIsNotEmpty(domainValues))
            return;

        const filters = domainValues.filter(d => d.code !== 'SIT' && d.dimensionCode !== 'D').map(f => <div key={f.domainId}
            className="v3-button" style={{ display: 'inline-flex', margin: '0 10px 2px 0' }}
            onClick={() => this.setState({ showSelectFilterPopup: true, filterIdToShow: f.domainId })}>
            + {f.domainName}
        </div>);

        const selectFilterPopup = this.state.showSelectFilterPopup ? this.getSelectFilterPopup() : undefined;

        const selectedFilters = this.state.selectedFilters.map(obj => getSelectedIndividualNode(domainValues, obj, this.removeFilter));

        const applyFilterButton = (
            <div className="v3-button"
                style={{ display: 'inline-flex', margin: '0 10px 2px 0', background: '#98DDE1', marginLeft: 'auto' }}
                onClick={this.onApplyFilters}  >
                Apply Filter
            </div>);

        return (<>
            <div style={{ borderTop: '3px solid #E5E5E5', padding: '10px 0 0 10px', marginBottom: '5px' }} className="flex justify-content-start align-items-flex-start">
                <div style={{ minWidth: 'max-content' }}>
                    <DateRangePicker
                        fromDate={this.state.fromDate}
                        toDate={this.state.toDate}
                        onClose={this.onSelectNewTimeRange} />
                </div>
                <div>
                    <Segmented
                        defaultValue={this.state.selectedTimePeriodicity}
                        onChange={this.setTimePeriodicity}
                        options={[
                            { label: "Daily", value: "Daily" },
                            { label: "Weekly", value: "Weekly" },
                            { label: "Monthly", value: "Monthly" },
                        ]}
                    />
                </div>
            </div>
            <div className="flex-wrap flex-container-end" style={{ marginLeft: '10px' }} >
                {filters}
                {applyFilterButton}
            </div >
            <div className="flex flex-space-between">
                <div style={{ display: 'inline-flex', flexWrap: 'wrap', alignItems: 'center', margin: '10px 0 10px 10px' }}>
                    {selectedFilters}
                    <div style={{ marginBottom: '1px' }}>
                        {selectFilterPopup}
                    </div>

                </div>
            </div>
        </>);
    }

    getTeamDashboardReport() {
        this.props.dispatch(updateProps({ isDownloadingReport: true }));
        this.props.dispatch(downloadTeamDashboardReport(this.state.fromDate, this.state.toDate, this.state.selectedTimePeriodicity));
    }

    getHeader = () => {
        const
            {
                isDownloadingReport,
                domainValues
            } = this.props;
        const { userTeams, currentTeamId } = this.state;

        const currentTeam = arrayIsNotEmpty(userTeams) ? userTeams.find(u => u.id === currentTeamId) : undefined;
        const teamNameNode = (<div className="title-secandary-400-12-14 cursor-pointer" onClick={this.showSelectTeamPopup} style={{ margin: '0 0 0 15px' }}>
            <div className="title-primary-400-24-28">
                <GroupIcon style={{ margin: '0 3px -3px 0', color: colors.primary200 }} />
                <span style={{ color: '#FF7700' }}>{currentTeam ? `Team ${currentTeam.name}` : undefined}</span>
            </div>
            {arrayIsNotEmpty(userTeams) && userTeams.length > 1 && < div className="title-secandary-400-12-14">Select another team</div>}
        </div>);

        const breakdownOptions = [{ value: "Overall" }, { value: "Agent", dimensionCode: 'Agent' }];
        if (arrayIsNotEmpty(domainValues)) {
            domainValues.map(d => {
                if (d.code !== 'SIT' && d.dimensionCode !== 'D') {
                    breakdownOptions.push({ value: d.domainName, dimensionCode: d.dimensionCode });
                }
            });
        }
        const filters = this.getFilters();

        return (<div className="sticky-panel">
            <div className="flex-container" style={{ padding: '5px 0px' }}>
                {teamNameNode}
                <div>
                    {isDownloadingReport && <LoadingControl />}
                    {!isDownloadingReport &&
                        <div className="export-button" onClick={() => this.getTeamDashboardReport()}>
                            <div className="export-button-text">Export</div>
                            <ExportIcon />
                        </div>}
                </div>
            </div>
            {filters}
            <div style={{ borderTop: '3px solid #E5E5E5' }}>
                <ToggleButtonGroup
                    items={breakdownOptions}
                    selectedItem={this.state.selectedPageBreakdown.value}
                    onItemClick={this.setPageBreakdown}
                />
            </div>
        </div>);
    }

    getBreakdownTicketCountChart = () => {
        const
            {
                ticketCountOverTimeByBreakdownStats,
            } = this.props;

        return <div className="system-dashboard-overall-border">
            <div className="flex-container" style={{
                minHeight: '38px', margin: '0 0 15px 0', borderBottom: '1px solid #E6F7F8',
            }}>
                <div>
                    <div className="title-primary-400-24-28">
                        Interaction Volume By {this.state.selectedPageBreakdown.value}
                    </div>
                    <div className="title-primary-400-24-28" style={{ fontSize: '14px' }}>
                        SHOWING {this.state.selectedPageBreakdown.value.toUpperCase()} VOLUME OVER TIME
                    </div>
                </div>
            </div>
            <GeneralAggregationChartWithExternalLegendContainer
                yAxis={yaxis_count}
                itemIdsActiveInLegend={this.state.selectedAggregationIdsInLegend}
                hideLegend={true}
                valueType="ticketCount"
                chartType="spline"
                allItemsBreakdownOverTimeStats={ticketCountOverTimeByBreakdownStats}
                propId="ChannelStackChart1" />
        </div>

    }

    getOverallTicketCountChart = () => {
        const
            {
                ticketCountOverTimeStats,
            } = this.props;

        return <div className="system-dashboard-overall-border">
            <div className="flex-container" style={{ minHeight: '38px', margin: '0 0 15px 0', borderBottom: '1px solid #E6F7F8' }}>
                <div>
                    <div className="title-primary-400-24-28">
                        Customer Interactions and Survey Volumes
                    </div>
                    <div className="title-primary-400-24-28" style={{ fontSize: '14px' }}>
                        SHOWING THE TREND BETWEEN CUSTOMER INTERACTIONS AND SURVEY VOLUMES
                    </div>
                </div>
            </div>
            <TicketCountProgressOverTimeContainer
                valueType="ticketCount"
                chartType="spline"
                ticketCountOverTimeStats={ticketCountOverTimeStats}
                propId="OverallTicketCountProgressOverTimeChart" />
        </div>
    }

    getBreakdownJibeScoreCharts = () => {
        const
            {
                jibeProgressBreakdownOverTimeStats,
                calibratedOnSurveyQuestions,
            } = this.props;
        if (!isDefined(calibratedOnSurveyQuestions)) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;
        }

        const responseCharts = calibratedOnSurveyQuestions.map((qc, index) => {
            return <div style={{ boxShadow: 'none', marginTop: '8px' }} key={index}>
                <div className="question-name-on-chart">{qc.nameForClient}:</div>
                <GeneralAggregationChartWithExternalLegendContainer
                    yAxis={yaxis_percentage}
                    itemIdsActiveInLegend={this.state.selectedAggregationIdsInLegend}
                    hideLegend={true}
                    maxX={110}
                    suffixY=" %"
                    questionCode={qc.questionCode}
                    valueType="overalSuccessRatePercent"
                    chartType="spline"
                    allItemsBreakdownOverTimeStats={jibeProgressBreakdownOverTimeStats}
                    propId={`JibeProgressOverTimeChart12${qc.questionCode}`} />
            </div>
        });
        return <>
            <div className="system-dashboard-overall-border">
                <div className="flex-container" style={{
                    minHeight: '38px', margin: '0 0 15px 0', borderBottom: '1px solid #E6F7F8',
                }}>
                    <div>
                        <div className="title-primary-400-24-28">
                            Jibe Prediction Accuracy By {this.state.selectedPageBreakdown.value}
                        </div>
                        <div className="title-primary-400-24-28" style={{ fontSize: '14px' }}>
                            SHOWING YOUR AGENTS PREDICTION ACCURACY OVER TIME BY {this.state.selectedPageBreakdown.value.toUpperCase()}
                        </div>
                    </div>
                </div>
                {responseCharts}
            </div>
        </>
    }

    getOverallJibeScoreCharts = () => {
        const
            {
                jibeProgressOverTimeStats,
                calibratedOnSurveyQuestions,
            } = this.props;
        if (!isDefined(calibratedOnSurveyQuestions)) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;
        }

        return <div className="system-dashboard-overall-border">
            <div className="flex-container" style={{
                minHeight: '38px', margin: '0 0 15px 0', borderBottom: '1px solid #E6F7F8',
            }}>
                <div>
                    <div className="title-primary-400-24-28">
                        Jibe Prediction Accuracy
                    </div>
                    <div className="title-primary-400-24-28" style={{ fontSize: '14px' }}>
                        SHOWING YOUR AGENTS PREDICTION ACCURACY OVER TIME
                    </div>
                </div>
            </div>
            <div style={{ boxShadow: 'none', marginTop: '8px' }}>
                <GeneralQuestionCodeChartContainer
                    valueType="overalSuccessRatePercent"
                    maxX={110}
                    suffixY=" %"
                    chartType="spline"
                    calibratedOnSurveyQuestions={calibratedOnSurveyQuestions}
                    jibeProgressOverTimeStats={jibeProgressOverTimeStats}
                    propId="JibeProgressOverTimeChart12" />
            </div>
            <br />
        </div>
    }

    getBreakdownResponseCharts = () => {
        const
            {
                responseBreakdownOverTimeStats,
                calibratedOnSurveyQuestions
            } = this.props;
        if (!isDefined(calibratedOnSurveyQuestions)) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;
        }

        const responses = calibratedOnSurveyQuestions.map((c, index) => {
            return (<div style={{ boxShadow: 'none', marginTop: '8px' }} key={index}>
                <div className="question-name-on-chart">{c.nameForClient}:</div>
                <GeneralAggregationChartWithExternalLegendWithCountContainer
                    itemIdsActiveInLegend={this.state.selectedAggregationIdsInLegend}
                    hideLegend={true}
                    questionCode={c.questionCode}
                    valueType="yesResponsePercentage"
                    chartType="spline"
                    allItemsBreakdownOverTimeStats={responseBreakdownOverTimeStats} />
            </div>

            );
        })
        return <>
            <div className="system-dashboard-overall-border">
                <div className="flex-container" style={{
                    minHeight: '38px', margin: '0 0 15px 0', borderBottom: '1px solid #E6F7F8',
                }}>
                    <div>
                        <div className="title-primary-400-24-28">
                            Performance By {this.state.selectedPageBreakdown.value}
                        </div>
                        <div className="title-primary-400-24-28" style={{ fontSize: '14px' }}>
                            SHOWING SURVEY RESPONSE PERFORMANCE OVER TIME BY {this.state.selectedPageBreakdown.value.toUpperCase()} - POSITIVE RESPONSE %
                        </div>
                    </div>
                </div>
                {responses}
            </div>
        </>
    }

    getOverallResponseCharts = () => {
        const
            {
                responseOverTimeStats,
                calibratedOnSurveyQuestions
            } = this.props;
        if (!isDefined(calibratedOnSurveyQuestions)) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;
        }

        const responseCharts = calibratedOnSurveyQuestions.map((qc, i) => {
            return <div style={{ boxShadow: 'none', marginTop: '8px' }} key={i}>
                <div className="question-name-on-chart">{qc.nameForClient}:</div>
                <ResponsesChartContainer
                    questionCode={qc.questionCode}
                    responselBreakdownOverTimeStats={responseOverTimeStats}
                    propId={`ResponsesChart${qc.questionCode}`} />
            </div>
        });
        return <>
            <div className="system-dashboard-overall-border">
                <div className="flex-container" style={{
                    minHeight: '38px', margin: '0 0 15px 0', borderBottom: '1px solid #E6F7F8',
                }}>
                    <div>
                        <div className="title-primary-400-24-28">
                            Survey Response Performance
                        </div>
                        <div className="title-primary-400-24-28" style={{ fontSize: '14px' }}>
                            SHOWING SURVEY RESPONSE PERFORMANCE OVER TIME
                        </div>
                    </div>
                </div>
                {responseCharts}
            </div>
        </>
    }

    getSummaryCard = (title, rowData, cardClassName) => {
        const className = "system-dashboard-overall-border child-fill-space " + cardClassName;
        if (arrayIsNotEmpty(rowData)) {
            const rows = rowData.map((r, i) => {
                let change;
                if (typeof r.change === 'string') {
                    change = parseFloat(r.change.replace('%', ''));
                } else {
                    change = r.change;
                }
                return (<div key={i}>
                    <div style={{ marginTop: '8px' }} >{r.title} </div>
                    <div className="flex-container justify-content-start" style={{ padding: '9px 0', borderBottom: '3px solid #E5E5E5' }}>
                        {isDefined(change) && < div className={`square-48-48 ${change > 0
                            ? "change-green-avatar"
                            : change == 0 ? "percentage-white-avatar" : "percentage-red-avatar"}`}>
                            <div className="square-48-48-content" >{r.change}</div>
                        </div>}
                        <div>
                            <div className="flex-container">
                                <div style={{ margin: '0 68px 0 8px' }}>Start Period</div>
                                <div style={{ margin: '0 8px 0 0' }}>{r.startPeriod}</div>
                                {r.startPeriodCount && <div>(Count: {r.startPeriodCount})</div>}
                            </div>
                            <div className="flex-container">
                                <div style={{ margin: '0 68px 0 8px' }}>End Period</div>
                                <div style={{ margin: '0 8px 0 0' }}>{r.endPeriod}</div>
                                {r.endPeriodCount && <div>(Count: {r.endPeriodCount})</div>}
                            </div>
                        </div>
                    </div>
                </div>)
            });
            return (<div className={className} style={{ margin: '5px' }}>
                <div className="title-primary-400-24-28" style={{ fontSize: '18px', borderBottom: '3px solid #E5E5E5' }}>{title}</div>

                {rows}
            </div>)
        }
        else {
            return (<div className={className} style={{ margin: '5px' }}>
                <div className="title-primary-400-24-28" style={{ fontSize: '18px', borderBottom: '3px solid #E5E5E5' }}>{title}</div>
                <LoadingControl />
            </div>)
        }
    }

    getJibeSummaryData = () => {
        const
            {
                jibeProgressOverTimeStats,
                calibratedOnSurveyQuestions,
            } = this.props;
        let jibeSummaryData = []
        if (!isDefined(calibratedOnSurveyQuestions) || !arrayIsNotEmpty(jibeProgressOverTimeStats)) {
            return;
        }
        calibratedOnSurveyQuestions.map(cq => {
            const endPeriodResult = jibeProgressOverTimeStats.reduce((highestIndexObject, currentObject) => {
                if (currentObject.questionCode === cq.questionCode && currentObject.dateIndex > highestIndexObject.dateIndex) {
                    return currentObject;
                }
                return highestIndexObject;
            }, { dateIndex: -Infinity });

            const firtsPeriodResult = jibeProgressOverTimeStats.find(jp => jp.questionCode === cq.questionCode && jp.dateIndex == 1);
            if (isDefined(firtsPeriodResult) && isDefined(endPeriodResult)) {
                const change = endPeriodResult.overalSuccessRatePercent - firtsPeriodResult.overalSuccessRatePercent;

                jibeSummaryData.push({
                    title: cq.nameForClient,
                    change: change,
                    startPeriod: `${firtsPeriodResult.overalSuccessRatePercent}%`,
                    endPeriod: `${endPeriodResult.overalSuccessRatePercent}%`
                });
            }
        });

        return jibeSummaryData;
    }

    getResponseSummaryData = () => {
        const
            {
                responseOverTimeStats,
                calibratedOnSurveyQuestions,
            } = this.props;
        let responseSummaryData = []
        if (!isDefined(calibratedOnSurveyQuestions) || !arrayIsNotEmpty(responseOverTimeStats)) {
            return;
        }

        calibratedOnSurveyQuestions.map(cq => {
            const maxDateIndex = responseOverTimeStats.reduce((max, item) => {
                return item.dateIndex !== undefined ? Math.max(max, item.dateIndex) : max;
            }, -Infinity);

            const firstPeriodResult = responseOverTimeStats.filter(response => response.questionCode === cq.questionCode && response.dateIndex == 1);
            const endPeriodResult = responseOverTimeStats.filter(response => response.questionCode === cq.questionCode && response.dateIndex == maxDateIndex);

            if (isDefined(firstPeriodResult) && isDefined(endPeriodResult)) {
                if (cq.questionCode === 'NPS') {
                    //end period
                    const endPeriodtotalEffectiveResponseCntRounded = endPeriodResult.reduce((sum, item) => sum + (item.effectiveResponseCntRounded || 0), 0);
                    const endPeriodpromoter = endPeriodResult.find(v => v.finalResponse === 'Promoter');
                    const endPerioddetractor = endPeriodResult.find(v => v.finalResponse === 'Detractor');
                    const endPeriodpromoterPercentage = isDefined(endPeriodpromoter) ? getPercentage(endPeriodpromoter.effectiveResponseCntRounded, endPeriodtotalEffectiveResponseCntRounded) : 0;
                    const endPerioddetractorPercentage = isDefined(endPerioddetractor) ? getPercentage(endPerioddetractor.effectiveResponseCntRounded, endPeriodtotalEffectiveResponseCntRounded) : 0;
                    const endNpsScore = endPeriodpromoterPercentage - endPerioddetractorPercentage;

                    //start period
                    const firstPeriodtotalEffectiveResponseCntRounded = firstPeriodResult.reduce((sum, item) => sum + (item.effectiveResponseCntRounded || 0), 0);
                    const firstPeriodpromoter = firstPeriodResult.find(v => v.finalResponse === 'Promoter');
                    const firstPerioddetractor = firstPeriodResult.find(v => v.finalResponse === 'Detractor');
                    const firstPeriodpromoterPercentage = isDefined(firstPeriodpromoter) ? getPercentage(firstPeriodpromoter.effectiveResponseCntRounded, firstPeriodtotalEffectiveResponseCntRounded) : 0;
                    const firstPerioddetractorPercentage = isDefined(firstPerioddetractor) ? getPercentage(firstPerioddetractor.effectiveResponseCntRounded, firstPeriodtotalEffectiveResponseCntRounded) : 0;
                    const firstNpsScore = firstPeriodpromoterPercentage - firstPerioddetractorPercentage;

                    responseSummaryData.push({
                        title: cq.nameForClient,
                        change: endNpsScore - firstNpsScore,
                        startPeriod: `${firstNpsScore}`,
                        startPeriodCount: firstPeriodtotalEffectiveResponseCntRounded,
                        endPeriod: `${endNpsScore}`,
                        endPeriodCount: endPeriodtotalEffectiveResponseCntRounded
                    });
                }
                else {
                    const endPeriodtotalEffectiveResponseCntRounded2 = endPeriodResult.reduce((sum, item) => sum + (item.effectiveResponseCntRounded || 0), 0);
                    const endPeriodPositiveResult = endPeriodResult.find(response => response.finalResponse === 'Yes' || response.finalResponse === 'Satisfied');
                    const endPeriodPositiveResulteffectiveResponseCntRounded = isDefined(endPeriodPositiveResult) ? endPeriodPositiveResult.effectiveResponseCntRounded : 0;
                    const endPeriodPositivePercentage = getPercentage(endPeriodPositiveResulteffectiveResponseCntRounded, endPeriodtotalEffectiveResponseCntRounded2);

                    const firstPeriodtotalEffectiveResponseCntRounded2 = firstPeriodResult.reduce((sum, item) => sum + (item.effectiveResponseCntRounded || 0), 0);
                    const firstPeriodPositiveResult = firstPeriodResult.find(response => response.finalResponse === 'Yes' || response.finalResponse === 'Satisfied');
                    const firstPeriodPositiveResulteffectiveResponseCntRounded = isDefined(firstPeriodPositiveResult) ? firstPeriodPositiveResult.effectiveResponseCntRounded : 0;
                    const firstPeriodPositivePercentage = getPercentage(firstPeriodPositiveResulteffectiveResponseCntRounded, firstPeriodtotalEffectiveResponseCntRounded2);

                    responseSummaryData.push({
                        title: cq.nameForClient,
                        change: `${endPeriodPositivePercentage - firstPeriodPositivePercentage}%`,
                        startPeriod: `${firstPeriodPositivePercentage}%`,
                        startPeriodCount: firstPeriodtotalEffectiveResponseCntRounded2,
                        endPeriod: `${endPeriodPositivePercentage}%`,
                        endPeriodCount: endPeriodtotalEffectiveResponseCntRounded2
                    });
                }
            }
        });

        return responseSummaryData;
    }

    getTicketCountSummaryData = () => {
        const
            {
                ticketCountOverTimeStats
            } = this.props;

        if (!arrayIsNotEmpty(ticketCountOverTimeStats)) {
            return;
        }

        const endPeriodResult = ticketCountOverTimeStats.reduce((highestIndexObject, response) => {
            if (response.dateIndex > highestIndexObject.dateIndex) {
                return response;
            }
            return highestIndexObject;
        }, { dateIndex: -Infinity });

        const firtsPeriodResult = ticketCountOverTimeStats.find(response => response.dateIndex == 1);

        if (isDefined(firtsPeriodResult) && isDefined(endPeriodResult)) {
            const ticketChange = getPercentageChange(firtsPeriodResult.tickets, endPeriodResult.tickets);
            const agentSurveysChange = getPercentageChange(firtsPeriodResult.agentSurveys, endPeriodResult.agentSurveys);
            const customerSurveysChange = getPercentageChange(firtsPeriodResult.customerSurveys, endPeriodResult.customerSurveys);
            return [{
                title: 'Tickets',
                change: ticketChange,
                startPeriod: firtsPeriodResult.tickets,
                endPeriod: endPeriodResult.tickets
            },
            {
                title: 'Agent Predictions',
                change: agentSurveysChange,
                startPeriod: firtsPeriodResult.agentSurveys,
                endPeriod: endPeriodResult.agentSurveys
            }, {
                title: 'Customer Surveys',
                change: customerSurveysChange,
                startPeriod: firtsPeriodResult.customerSurveys,
                endPeriod: endPeriodResult.customerSurveys
            }];
        }
    }

    getPeriodicityName = () => {
        if (this.state.selectedTimePeriodicity == "Weekly") {
            return "Week";
        }
        else if (this.state.selectedTimePeriodicity == "Daily") {
            return "Day";
        }
        else if (this.state.selectedTimePeriodicity == "Monthly") {
            return "Month";
        }
    }

    getOverallSummaryNode = () => {
        if (this.state.selectedPageBreakdown.value === "Overall") {

            const ticketCountRowsData = this.getTicketCountSummaryData();
            const ticketCountSummary = this.getSummaryCard('Interactions and Survey Volumes', ticketCountRowsData, 'gradient-blue-div');

            const jibeRowsData = this.getJibeSummaryData();
            const jibeSummary = this.getSummaryCard('Jibe Prediction Accuracy', jibeRowsData, 'gradient-orange-div');

            const responseRowsData = this.getResponseSummaryData();
            const responseSummary = this.getSummaryCard('Survey Response Performance', responseRowsData, 'gradient-purple-div');

            const periodicityUnit = this.getPeriodicityName();

            return <div className="system-dashboard-overall-border" style={{ marginTop: '7px' }}>
                <div className="flex-container"
                    style={{ minHeight: '38px', margin: '0 0 15px 0', borderBottom: '1px solid #E6F7F8' }}>
                    <div>
                        <div className="title-primary-400-24-28">
                            Summary
                        </div>
                        <div className="title-primary-400-24-28" style={{ fontSize: '14px' }}>
                            Comparing Start Period: {periodicityUnit} of {this.state.fromDate.slice(0, 5)} and End Period: {periodicityUnit} of {this.state.toDate.slice(0, 5)}
                        </div>
                    </div>
                </div>
                <div className="flex-basic justify-content-space-evenly ">
                    {ticketCountSummary}
                    {jibeSummary}
                    {responseSummary}
                </div>
            </div>
        }
    }

    getBreakdownSummaryNode = () => {
    }

    handleCheckboxChange = (id) => {
        const { selectedAggregationIdsInLegend } = this.state;
        if (selectedAggregationIdsInLegend.includes(id)) {
            this.setState({
                selectedAggregationIdsInLegend: selectedAggregationIdsInLegend.filter((selectedId) => selectedId !== id)
            });
        } else {
            this.setState({
                selectedAggregationIdsInLegend: [...selectedAggregationIdsInLegend, id]
            });
        }
    }

    initSelectedAggregationIdsInLegend = (payload) => {
        if (!arrayIsNotEmpty(payload)) {
            return;
        }

        const uniqueIdNameArray = this.getLegendItems(payload);

        if (arrayIsNotEmpty(uniqueIdNameArray)) {
            const firstItem = uniqueIdNameArray[0];
            this.setState({ selectedAggregationIdsInLegend: [firstItem.id] });
            if (uniqueIdNameArray.length > 1) {
                const secondItem = uniqueIdNameArray[1];
                this.setState({ selectedAggregationIdsInLegend: [firstItem.id, secondItem.id] });
            }
        }
    }

    getLegendItems = (ticketCountOverTimeByBreakdownStats) => {
        let uniqueIds = new Set();
        let uniqueIdNameArray = ticketCountOverTimeByBreakdownStats.filter(obj => {
            if (!uniqueIds.has(obj.aggregationId)) {
                uniqueIds.add(obj.aggregationId);
                return true;
            }
            return false;
        }).map(({ aggregationId, aggregationName }) => ({ id: aggregationId, name: aggregationName }));


        uniqueIdNameArray.sort((a, b) => {
            if (a.name > b.name) return 1;
            if (a.name < b.name) return -1;
            return 0;
        });

        //Move the item with id == -1 to the end
        if (arrayIsNotEmpty(uniqueIdNameArray) && uniqueIdNameArray[0].id == -1) {
            const firstItem = uniqueIdNameArray.shift();
            uniqueIdNameArray.push(firstItem);
        }
        return uniqueIdNameArray;
    }

    getLegend = () => {
        const
            {
                ticketCountOverTimeByBreakdownStats,
            } = this.props;
        if (!arrayIsNotEmpty(ticketCountOverTimeByBreakdownStats)) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;
        }

        const uniqueIdNameArray = this.getLegendItems(ticketCountOverTimeByBreakdownStats);

        return <div className="legend">
            {uniqueIdNameArray.map((t, i) => {
                const color = getColorById(t.id);
                return <div className="flex" style={{ width: 'max-content' }} key={i}>
                    <input
                        type="checkbox"
                        id={t.id}
                        value={t.id}
                        checked={this.state.selectedAggregationIdsInLegend.includes(t.id)}
                        onChange={() => this.handleCheckboxChange(t.id)}
                        className="checkbox-custom"
                    />
                    <div className="legend-line" style={{ borderTop: `5px solid ${color}` }}></div>
                    <label htmlFor={t.id}>{t.name}</label>
                </div>
            })}</div>;
    }

    getPageCharts() {
        if (this.state.selectedPageBreakdown.value === "Overall") {
            const summaryNode = this.getOverallSummaryNode();
            const ticketCountChart = this.getOverallTicketCountChart();
            const jibeScoreChart = this.getOverallJibeScoreCharts();
            const responseCharts = this.getOverallResponseCharts();
            return <>
                {summaryNode}
                <br />
                {ticketCountChart}
                <br />
                {jibeScoreChart}
                <br />
                {responseCharts}
                <br />
            </>
        }
        else {
            const breakdownTicketCountChart = this.getBreakdownTicketCountChart();
            const breakdownJibeScoreChart = this.getBreakdownJibeScoreCharts();
            const breakdownResponseCharts = this.getBreakdownResponseCharts();
            const legend = this.getLegend();
            return <div className="flex-basic">
                <div className="chart-panel-without-legend">
                    {breakdownTicketCountChart}
                    <br />
                    {breakdownJibeScoreChart}
                    <br />
                    {breakdownResponseCharts}
                    <br />
                </div>
                {legend}
            </div >
        }
    }

    showSelectTeamPopup = () => {
        this.setState({ showSelectTeamPopup: true });
    }

    hideSelectTeamPopup = (selectedTeam) => {
        this.setState({ showSelectTeamPopup: false });

        if (arrayIsNotEmpty(selectedTeam) && this.state.currentTeamId !== selectedTeam[0].id) {
            this.setState({ currentTeamId: selectedTeam[0].id });

            //// Get new data
            this.props.dispatch(loadTeamDashboardOverallScreen(this.state.fromDate, this.state.toDate, this.state.selectedTimePeriodicity,
                selectedTeam[0].id, this.state.selectedFilters, this.state.supervisorDomainId));

            //// wipe the old data
            this.props.dispatch(updateProps({
                ticketCountOverTimeStats: undefined,
                jibeProgressOverTimeStats: undefined,
                responseOverTimeStats: undefined,
            }));
        }
    }

    getSelectTeamPopup = () => {
        const { userTeams } = this.state;

        if (!userTeams)
            return;

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectTeam">
                <SelectTable
                    selectMultiple={false}
                    title="Select team"
                    searchPlaceHolder="Search..."
                    options={userTeams}
                    onClose={this.hideSelectTeamPopup} />
            </div>
        </div>);
    }

    render() {
        const
            {
                currentUser
            } = this.props;

        if (!currentUser) {
            return (<div style={{ minHeight: '101px', marginLeft: '45px' }}>
                <div>
                    <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="163" />
                </div>
            </div>)
        }

        if (currentUser.RoleId == ZRole.Agent) {
            this.redirectIfNeeded();
            return <div></div>;
        }

        const header = this.getHeader();
        const charts = this.getPageCharts();

        const selectTeamPopup = this.state.showSelectTeamPopup ? this.getSelectTeamPopup() : undefined;

        return (<div className="main-page-width">

            {selectTeamPopup}
            {header}
            {charts}
        </div >);
    }
}

const select = state => ({ ...state.TeamDashboardScreen, ...state.session });

export default connect(select)(TeamDashboardScreen);